module.exports = __webpack_public_path__ + "static/media/yes.eca34638.svg";